<template>
	<div >
		<div class="app-container">
			<el-descriptions title="检查项目" :column="1" border>
				<el-descriptions-item labelStyle="width:120px">
					<template slot="label" >						 
						检验项目
					</template>
					 {{ypcjxx.xmJcxm}}
				</el-descriptions-item>				
				<el-descriptions-item>
					<template slot="label">						
						标准规定
					</template>
					 {{ypcjxx.xmBzgd}}
				</el-descriptions-item>				 
				 <el-descriptions-item>
				 	<template slot="label">						
				 		检验结论
				 	</template>
				 	 {{ypcjxx.xmXmjyjl22989}}
				 </el-descriptions-item>
			</el-descriptions>
			<el-descriptions title="检查报告" :column="2" border>
				<el-descriptions-item labelStyle="width:120px">
					<template slot="label" >						 
						报告编号
					</template>
					 {{ypcjxx.bgJybgbh}}
				</el-descriptions-item>		
				<el-descriptions-item labelStyle="width:120px">
					<template slot="label" >						 
						报告日期
					</template>
					 {{ypcjxx.bgRqBg}}
				</el-descriptions-item>	
				<el-descriptions-item>
					<template slot="label">						
						检验结果
					</template>
					 {{ypcjxx.bgJyjgms}}
				</el-descriptions-item>				 
				 <el-descriptions-item>
				 	<template slot="label">						
				 		检验结论
				 	</template>
				 	 {{ypcjxx.bgJyjl}}
				 </el-descriptions-item>
				 <el-descriptions-item>
				 	<template slot="label">						
				 		检验依据
				 	</template>
				 	 {{ypcjxx.bgJyyj}}
				 </el-descriptions-item>
				 <el-descriptions-item>
				 	<template slot="label">						
				 		检验目的
				 	</template>
				 	 {{ypcjxx.bgJymd}}
				 </el-descriptions-item>
				 <el-descriptions-item>
				 	<template slot="label">						
				 		检验日期
				 	</template>
				 	 {{ypcjxx.bgRqJy}}
				 </el-descriptions-item>
				 <el-descriptions-item>
				 	<template slot="label">						
				 		是否复检
				 	</template>
				 	 {{ypcjxx.bgSffj}}
				 </el-descriptions-item>
				 <el-descriptions-item>
				 	<template slot="label">						
				 		复检机构
				 	</template>
				 	 {{ypcjxx.bgFjjgbm}}
				 </el-descriptions-item>
				 <el-descriptions-item>
				 	<template slot="label">						
				 		复检结果
				 	</template>
				 	 {{ypcjxx.bgFjjg}}
				 </el-descriptions-item>
				 <el-descriptions-item>
				 	<template slot="label">						
				 		复检说明
				 	</template>
				 	 {{ypcjxx.bgFjsm}}
				 </el-descriptions-item>	 
			</el-descriptions>
			<el-descriptions title="抽样信息" :column="2" border>
				<el-descriptions-item labelStyle="width:120px">
					<template slot="label" >						 
						抽样时间
					</template>
					 {{ypcjxx.cyRqCy}}
				</el-descriptions-item>				
				<el-descriptions-item>
					<template slot="label">						
						任务
					</template>
					 {{ypcjxx.cyRwlynr}}
				</el-descriptions-item>				 
				 <el-descriptions-item>
				 	<template slot="label">						
				 		抽样单位名称
				 	</template>
				 	 {{ypcjxx.cyCydwmc}}
				 </el-descriptions-item>
				 <el-descriptions-item>
				 	<template slot="label">						
				 		被抽样单位名称
				 	</template>
				 	 {{ypcjxx.cyBcydwmc}}
				 </el-descriptions-item>
				 <el-descriptions-item>
				 	<template slot="label">						
				 		生产单位名称
				 	</template>
				 	 {{ypcjxx.cyScdwmc}}
				 </el-descriptions-item>
				 <el-descriptions-item>
				 	<template slot="label">						
				 		药品通用名
				 	</template>
				 	 {{ypcjxx.cyYpmc}}
				 </el-descriptions-item>
				 <el-descriptions-item>
				 	<template slot="label">						
				 		批号
				 	</template>
				 	 {{ypcjxx.cyPh}}
				 </el-descriptions-item>
				 <el-descriptions-item>
				 	<template slot="label">						
				 		包装规格
				 	</template>
				 	 {{ypcjxx.cyBzgg}}
				 </el-descriptions-item>
				 <el-descriptions-item>
				 	<template slot="label">						
				 		制剂规格
				 	</template>
				 	 {{ypcjxx.cyZjgg}}
				 </el-descriptions-item>
				 <el-descriptions-item>
				 	<template slot="label">						
				 		有效期至
				 	</template>
				 	 {{ypcjxx.cyRqYxqz}}
				 </el-descriptions-item>
				 <el-descriptions-item>
				 	<template slot="label">						
				 		抽样数量
				 	</template>
				 	 {{ypcjxx.cyCysl}}
				 </el-descriptions-item>
				 <el-descriptions-item>
				 	<template slot="label">						
				 		抽样生产日期
				 	</template>
				 	 {{ypcjxx.cyRqSc}}
				 </el-descriptions-item>
			</el-descriptions>
			 
		</div>
	</div>
</template>

<script> 
	export default {
		name: 'Ypcjxx',
		props: {
			//药品抽检信息
			ypcjxx: {
				type: Object,
				require: true
			}
		},
		watch: {
			ypcjxx(newValue, oldValue) {
				//this.init();
			},
			immediate: true,
			deep: true,
		},
		data() {
			return {
				 
			}
		},
		created() {
			//this.init();
			 
		},
		methods: {
			 
		}
	}
</script>

<style scoped>
	/deep/ .el-descriptions__header {
		display: flex;
		justify-content: space-between;
		align-items: center;
		margin-bottom: 0px;
	}

	.el-title {
		box-sizing: border-box;
		font-size: 16px;
		font-weight: 700;
		color: #303133;
		padding-top: 10px;
		text-align: left;
	}
</style>
